<template>
  <div class="flex w-full" style="height: 100%" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" @dblclick="copyValueToClipboard">
    
    <p v-if="getType === 'Default'" :class="getColor"> {{ checkValue(params.valueFormatted || params.value) }} </p>
    
    <vs-chip v-else-if="getType === 'Chip'" style="height: 70%; width: 100%" class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ chipText(params.value) || 'NA' }}</span>
    </vs-chip>
    <!-- :class="[params.valueFormatted && params.valueFormatted.indexOf('\x24 ') >= 0 ? 'alingCenterContent' : '']" -->
  </div>
</template>
<script>
export default {
  methods: {
    copyValueToClipboard () {
      // console.error(this)
      const thisIns = this
      this.$copyText(thisIns.checkValue(thisIns.params.valueFormatted || thisIns.params.value)).then(function () {
        thisIns.$vs.notify({
          title: 'Success',
          text: 'Text copied successfully',
          color: 'success',
          iconPack: 'feather',
          position: 'top-center',
          icon: 'icon-check-circle'
        })
      }, function () {
        thisIns.$vs.notify({
          title: 'Failed',
          text: 'Error in copying text',
          color: 'danger',
          iconPack: 'feather',
          position: 'top-center',
          icon: 'icon-alert-circle'
        })
      })
    }
  },
  computed: {
    getType () {
      const type = this.params.column.colDef.contentType
      
      if (type === null || type === undefined) return 'Default'
      else if (type === 'chip') return 'Chip'
    },
    chipColor () {
      return (value) => {
        let res = 'primary'
        if (this.params.column.colDef.contentOptions !== undefined) {
          this.params.column.colDef.contentOptions.forEach(element => {
            if (element.value === value) res = element.chipColor
          })
        }
        return res
      }
    },
    chipText () {
      return (value) => {
        let res = value
        if (this.params.column.colDef.contentOptions !== undefined) {
          this.params.column.colDef.contentOptions.forEach(element => {
            if (element.value === value) res = element.chipText
          })
        }
        return res
      }
    },
    checkValue () {
      return (value) => {
        let res = value
        if (this.params.column.colDef.contentOptions !== undefined) {
          this.params.column.colDef.contentOptions.forEach(element => {
            if (element.value === value) res = element.chipText
          })
        }
        return res
      }
    },
    getColor () {
      if (this.params.column.colDef.textColor === undefined) return ''
      if (this.params.column.colDef.textColor === 'fixTextColor') return this.params.column.colDef.fixTextColor
      else return this.params.value > 0 ? 'text-primary' : 'text-danger'
    }
  }
//   <style scoped>
//   .alingCenterContent {
//     width: 100% !important;
//     text-align: center;
//   }
// </style>
}
</script>
